const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})/;
const DISPLAY_DATE = /^(\d{2})\/(\d{2})\/(\d{4})$/;

export const maskReferenceDate = value => {
  let maskedValue = String(value || '').replace(/\D/g, '');
  maskedValue = maskedValue.replace(/(\d{2})(\d)/, '$1/$2');
  maskedValue = maskedValue.replace(/(\d{2})(\d)/, '$1/$2');
  return maskedValue.replace(/(\d{4})(\d)/, '$1');
};

export const displayReferenceDate = value => {
  const rawValue = String(value || '');
  const isoParts = rawValue.match(ISO_DATE);
  if (!isoParts) return maskReferenceDate(rawValue);

  return `${isoParts[3]}/${isoParts[2]}/${isoParts[1]}`;
};

export const apiReferenceDate = value => {
  const rawValue = String(value || '');
  const displayParts = rawValue.match(DISPLAY_DATE);
  if (displayParts) {
    return `${displayParts[3]}-${displayParts[2]}-${displayParts[1]}`;
  }

  return rawValue.match(ISO_DATE)?.[0] || '';
};

export const referenceDateComplete = value => String(value || '').length === 10;
